export const getWalletAdjustmentAmount = (operation, amount) => {
  if (amount === "" || amount === null || amount === undefined) return null

  const numericAmount = Number(amount)
  if (!Number.isFinite(numericAmount) || numericAmount === 0) return null

  if (operation === "subtract") return -Math.abs(numericAmount)
  if (numericAmount < 0) return null

  return numericAmount
}

export const getWalletBalancePreview = (currentBalance, adjustment) => {
  const balance = Number(currentBalance)
  const delta = Number(adjustment)

  return (Number.isFinite(balance) ? balance : 0) +
    (Number.isFinite(delta) ? delta : 0)
}
